<template>
  <div>
    <OutsidePageBackground></OutsidePageBackground>
    <div class="main">
      <div class="captcha_shade" v-show="captchaShade">
        <i class="close el-icon-close" @click="captchaShade = false"></i>
        <div class="captcha_wrapper" ref="login_captcha_div"></div>
      </div>
      <el-tabs v-model="active" tab-position="right">
        <el-tab-pane  v-if="login.enabled" name="login" label="登陆">
          <el-form :model="login.form" :rules="login.rules" ref="loginForm">
            <el-form-item prop="account">
              <el-input v-model="login.form.account" placeholder="邮箱/手机号/IM号"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input v-model="login.form.password" placeholder="密码" show-password @keyup.enter.native="loginFun"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" class="full_btn" :loading="login.btnLoading" @click="loginFun">
                登陆
              </el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane v-if="smsLogin.enabled" name="smsLogin" label="短信登陆">
          <el-form :model="smsLogin.form" :rules="smsLogin.rules" ref="smsLoginForm">
            <el-form-item prop="phone">
              <el-input v-model="smsLogin.form.phone" placeholder="手机号"></el-input>
            </el-form-item>
            <el-form-item prop="dynamicNum">
              <el-row :gutter="10">
                <el-col :span="15">
                  <el-input v-model="smsLogin.form.dynamicNum" placeholder="动态码" @keyup.enter.native="smsLoginFun" maxlength="6"></el-input>
                </el-col>
                <el-col :span="9">
                  <el-button size="small" class="full_btn" :disabled="smsLogin.smsBtn" @click="sendLoginSmsFun">{{smsLogin.btnText}}</el-button>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" class="full_btn" @click="smsLoginFun" :loading="smsLogin.loginBtn">登陆
              </el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane v-if="register.enabled" name="register" label="注册">
          <el-form :model="register.form" :rules="register.rules" ref="registerForm">
            <el-form-item prop="phone">
              <el-input v-model="register.form.phone" placeholder="手机号"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input v-model="register.form.password" show-password placeholder="密码"></el-input>
            </el-form-item>
            <el-form-item prop="secondsPassword" v-show="register.form.password">
              <el-input v-model="register.form.secondsPassword" show-password placeholder="确认密码"></el-input>
            </el-form-item>
            <el-form-item prop="dynamicNum">
              <el-row :gutter="10">
                <el-col :span="15">
                  <el-input v-model="register.form.dynamicNum" placeholder="动态码" maxlength="6"></el-input>
                </el-col>
                <el-col :span="9">
                  <el-button size="small" class="full_btn" :disabled="register.smsBtn" @click="sendRegisterSmsFun">{{register.btnText}}</el-button>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item>
              <el-button type="success" class="full_btn" @click="registerFun" :loading="register.registerBtn">注册</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane v-if="emailRegister.enabled" name="emailRegister" label="邮箱注册">
          <el-form :model="emailRegister.form" :rules="emailRegister.rules" ref="emailRegisterForm" @submit.native.prevent>
            <el-form-item prop="email" >
              <el-input v-model="emailRegister.form.email" placeholder="邮箱"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="success" class="full_btn" @click="emailRegisterFun" :loading="emailRegister.createBtn">创建账号</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane v-if="resetPassword.enabled" name="resetPassword" label="忘记密码">
          <el-form :model="resetPassword.form" :rules="resetPassword.rules" ref="resetPasswordForm" @submit.native.prevent>
            <el-form-item prop="account">
              <el-input v-model="resetPassword.form.account" placeholder="邮箱/手机号"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="success" class="full_btn" @click="resetPasswordFun" :loading="resetPassword.resetPasswordBtn">找回密码</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>
    <IcpFooter></IcpFooter>
  </div>
</template>
<script>
    import md5 from 'js-md5';
    import {checkPassword, checkIMNumber, checkPhone, checkEmail} from "../js/utils/regular"
    import setting from "../config/setting";
    import IcpFooter from "./component/IcpFooter";
    import OutsidePageBackground from "./component/OutsidePageBackground";

    export default {
        name: "Index",
        components: {IcpFooter, OutsidePageBackground},
        data() {
            return {
                active: "login",
                captchaShade:
                    false,
                login: {
                    enabled: true,
                    rules: {
                        account: [
                            {
                                validator: (rule, value, callback) => {
                                    checkEmail(value) || checkIMNumber(value) || checkPhone(value) ? callback() : callback('账号格式不正确');
                                }, trigger: 'blur'
                            }
                        ],
                        password: [
                            {
                                validator: (rule, value, callback) => {
                                  (value.length >= 8 && value.length <= 18) ? callback() : callback('密码格式不正确');
                                }, trigger: 'blur'
                            }
                        ],
                    },
                    form: {
                        account: "",
                        password: "",
                    },
                    btnLoading: false,
                },
                smsLogin: {
                    enabled: false,
                    rules: {
                        phone: [
                            {
                                validator: (rule, value, callback) => {
                                    checkPhone(value) ? callback() : callback('手机号格式不正确');
                                }, trigger: 'blur'
                            }
                        ],
                        dynamicNum: [
                            {
                                validator: (rule, value, callback) => {
                                    value ? callback() : callback('请输入验证码');
                                }, trigger: 'blur'
                            }
                        ],
                    },
                    form: {
                        phone: "",
                        dynamicNum:"",
                    },
                    btnText: "获取验证码",
                    smsBtn: false,
                    loginBtn: false,
                },
                register: {
                    enabled: false,
                    rules: {
                        phone: [
                            {
                                validator: (rule, value, callback) => {
                                    checkPhone(value) ? callback() : callback('手机号格式不正确');
                                }, trigger: 'blur'
                            }
                        ],
                        password: [
                            {
                                validator: (rule, value, callback) => {
                                    checkPassword(value)
                                        ? callback() & (this.register.form.secondsPassword && this.$refs.registerForm.validateField(['secondsPassword']))
                                        : callback('密码格式6-18位字符');
                                }, trigger: 'blur'
                            }
                        ],
                        secondsPassword: [
                            {
                                validator: (rule, value, callback) => {
                                    this.register.form.password === value ? callback() : callback('密码不一致');
                                }, trigger: 'blur'
                            }
                        ],
                        dynamicNum: [
                            {
                                validator: (rule, value, callback) => {
                                    value ? callback() : callback('请输入验证码');
                                }, trigger: 'blur'
                            }
                        ]
                    },
                    form: {
                        phone: "",
                        password: "",
                        secondsPassword: '',
                        showSecondsPassword: false,
                        dynamicNum: "",
                    },
                    smsBtn: false,
                    registerBtn: false,
                    btnText: "获取验证码",
                },
                emailRegister: {
                    enabled: true,
                    rules: {
                        email: [
                            {
                                validator: (rule, value, callback) => {
                                    checkEmail(value) ? callback() : callback('邮箱格式不正确');
                                }, trigger: 'blur'
                            }
                        ],
                    },
                    form: {
                        email: "",
                    },
                    createBtn: false,
                },
                resetPassword: {
                    enabled: true,
                    rules: {
                        account: [
                            {
                                validator: (rule, value, callback) => {
                                    checkEmail(value) || checkPhone(value) ? callback() : callback('请输入正确账号');
                                }, trigger: 'blur'
                            }
                        ],
                    },
                    form: {
                        account: "",
                    },
                    resetPasswordBtn: false,
                },

            }
        },
        created() {
            if (this[this.$route.name] && this[this.$route.name].enabled)
              this.active = this.$route.name;
        },
        methods: {
            captcha(callback) {
                this.captchaShade = true;
                let self = this;
                _dx.Captcha(this.$refs.login_captcha_div, {
                    appId: setting.dxCaptchaAppId,
                    style: "inline",
                    inlineFloatPosition: 'down',
                    success: function (ticket) {
                        callback(ticket);
                        setTimeout(() => {
                            self.captchaShade = false;
                        }, 1000);
                    }
                });
            },
            loginFun() {
                this.$refs.loginForm.validate().then(() => {
                    let {account, password} = this.login.form;
                    this.captcha((ticket) => {
                        this.login.btnLoading = true;
                        this.$im.login("/USER/v1/users/login", {
                            account: account,
                            password: md5(password),
                            ticket: ticket,
                        }, null, null, (msg) => {
                            this.login.btnLoading = false;
                            this.$im.showMessage(msg, {icon: 5});
                        });
                    })
                }).catch(() => {});
            },
            sendLoginSmsFun() {
                this.$refs.smsLoginForm.validateField(['phone'], (msg) => {
                    if (msg)
                        return;
                    let {phone} = this.smsLogin.form;
                    this.captcha((ticket) => {
                        this.smsLogin.smsBtn = true;
                        this.$im.get("/USER/v1/sms", {phone: phone, ticket: ticket, type: "LOGIN"}, false, () => {
                            this.smsLogin.btnText = 60;
                            let timer = setInterval(() => {
                                if (this.smsLogin.btnText !== 1) {
                                    this.smsLogin.btnText -= 1;
                                } else {
                                    clearInterval(timer);
                                    this.smsLogin.btnText = "获取验证码";
                                    this.smsLogin.smsBtn = false;
                                }
                            }, 1000);
                        }, null, (msg) => {
                            this.smsLogin.smsBtn = false;
                            this.$im.showMessage(msg, {icon: 5});
                        });
                    })
                });
            },
            smsLoginFun() {
                this.$refs.smsLoginForm.validate().then(() => {
                    let {phone, dynamicNum} = this.smsLogin.form;
                    this.smsLogin.loginBtn = true;
                    this.$im.login("/USER/v1/users/sms-login", {
                        account: phone,
                        dynamicNum: dynamicNum,
                    }, null, null, (msg) => {
                        this.smsLogin.loginBtn = false;
                        this.$im.showMessage(msg, {icon: 5});
                    })
                }).catch(() => {});
            },
            sendRegisterSmsFun() {
                this.$refs.registerForm.validateField(['phone'], (msg) => {
                    if (msg)
                        return;
                    this.captcha((ticket) => {
                        this.register.smsBtn = true;
                        this.$im.get("/USER/v1/sms", {phone: this.register.form.phone, ticket: ticket, type: "REGISTER"}, false, () => {
                            this.register.btnText = 60;
                            let timer = setInterval(() => {
                                if (this.register.btnText !== 1) {
                                    this.register.btnText -= 1;
                                } else {
                                    clearInterval(timer);
                                    this.register.btnText = "获取验证码";
                                    this.register.smsBtn = false;
                                }
                            }, 1000);
                        }, null, (msg) => {
                            this.register.smsBtn = false;
                            this.$im.showMessage(msg, {icon: 5});
                        });
                    })
                });
            },
            registerFun() {
                this.$refs.registerForm.validate().then(() => {
                    this.register.registerBtn = true;
                    let {phone, password, dynamicNum} = this.register.form;
                    this.$im.post("/USER/v1/users/register", {
                        account: phone,
                        password: md5(password),
                        dynamicNum: dynamicNum
                    }, false, () => {
                        this.$refs.registerForm.resetFields();
                        this.$im.showMessage("注册成功", {icon: 1});
                        this.active = "smsLogin";
                        // this.active = "login";
                    }, () => {
                        this.register.registerBtn = false;
                    }, (msg) => {
                        this.$im.showMessage(msg, {icon: 5});
                    });
                }).catch(() => {});
            },
            emailRegisterFun() {
                this.$refs.emailRegisterForm.validate().then(() => {
                    this.captcha((ticket) => {
                        this.emailRegister.createBtn = true;
                        let {email} = this.emailRegister.form;
                        this.$im.post("/USER/v1/users/email-register", {
                            account: email,
                            ticket: ticket
                        }, false, () => {
                            this.$refs.emailRegisterForm.resetFields();
                            this.$im.showNotify('创建成功', '邮件已发送，请前往邮箱激活账号', 'success', -1)
                        }, () => {
                            this.emailRegister.createBtn = false;
                        }, (msg) => {
                            this.$im.showMessage(msg, {icon: 5});
                        });
                    });
                }).catch(() => {});
            },
            resetPasswordFun() {
                this.$refs.resetPasswordForm.validate().then(() => {
                    this.captcha((ticket) => {
                        this.resetPassword.resetPasswordBtn = true;
                        let {account} = this.resetPassword.form;
                        if (checkEmail(account)) {
                            this.$im.post("/USER/v1/users/send-reset-password", {
                                account: account,
                                ticket: ticket
                            }, false, () => {
                                this.$refs.resetPasswordForm.resetFields();
                                this.$im.showNotify('发送成功', '邮件已发送，请前往邮件链接重置密码', 'success', -1)
                            }, () => {
                                this.resetPassword.resetPasswordBtn = false;
                            }, (msg) => {
                                this.$im.showMessage(msg, {icon: 5});
                            });
                        } else if (checkPhone(account)) {
                            this.$im.showMessage("暂不支持手机号重置", {icon: 5});
                        }
                    });
                }).catch(() => {});
            },
        },
    }
</script>

<style scoped>
  .captcha_shade {
    position: absolute;
    z-index: 100;
    top: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    right: 0;
  }

  .captcha_shade .captcha_wrapper {
    margin: 15px 0 0 15px;
  }

  .main {
    padding: 25px 0 9px 25px;
    width: 400px;
    position: fixed;
    right: 100px;
    top: 120px;
    background-color: white;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
  }

  .captcha_shade .close {
    color: #fff;
    position: absolute;
    top: 5%;
    font-size: 25px;
    right: 5%;
    cursor: pointer;
  }

  .full_btn {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/view/Index.vue